import React, { useState } from 'react';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { FormattedMessage } from 'react-intl';

import { Button } from '@components/Base/Button';
import { Dropdown } from '@components/Base/Dropdown';
import SearchInput from '@components/Base/Input';
import DateRangePicker from '@components/Shared/DateRangePicker';
import SidePanel from '@components/SidePanel';
import messages from '@components/Transactions/Filters/messages';
import './styles.css';
import { AppliedFilters } from '@containers/transactions';
import { statusList } from '@containers/transactions/types';

export interface TransactionsFiltersProps {
  toogleFilterView: () => void;
  showFilter: boolean;
  countryList: { label: string; value: string }[];
  handleApplyFilters: (filters: AppliedFilters) => void;
  appliedFilters: AppliedFilters;
}

const Filters = (props: TransactionsFiltersProps) => {
  const { showFilter, toogleFilterView, appliedFilters, handleApplyFilters } = props;
  const [selectedDateRange, setSelectedDateRange] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  } | null>(appliedFilters.selectedDateRange ?? null);
  const [transactionId, setTransactionId] = useState<string>(appliedFilters.transactionId ?? '');
  // const [driveEnrollmentId, setDriveEnrollmentId] = useState<string>('');
  const [attendee, setAttendee] = useState<string>('');
  // const [voucherCode, setVoucherCode] = useState<string>('');
  // const [invoiceId, setInvoiceId] = useState<string>('');

  const [selectedStatus, setSelectedStatus] = useState<
    | {
        label: string;
        value: string;
      }[]
    | null
  >(appliedFilters.selectedStatus ?? null);

  // NOTE: Hide for https://github.com/talview/webclients/issues/4921
  // const [selectedWorkflow, setSelectedWorkflow] = useState<
  //   | {
  //       label: string;
  //       value: string;
  //     }[]
  //   | null
  // >(null);
  //
  // const [selectedTransactionAction, setTransactionAction] = useState<
  //   | {
  //       label: string;
  //       value: string;
  //     }[]
  //   | null
  // >(null);
  //
  // const [selectedCountry, setSelectedCountry] = useState<
  //   | {
  //       label: string;
  //       value: number | string;
  //     }[]
  //   | null
  // >(null);

  const clearFilters = () => {
    setSelectedStatus(null);
    setAttendee('');
    setSelectedDateRange(null);
    setTransactionId('');
    setAttendee('');
    handleApplyFilters({});
    // setDriveEnrollmentId('');
    // setVoucherCode('');
    // setSelectedCountry(null);
    // setInvoiceId('');
    // setSelectedWorkflow(null);
  };

  const resetFilter = () => {
    clearFilters();
    toogleFilterView();
  };

  const applyFilter = () => {
    const filters = {
      transactionId: transactionId,
      selectedStatus: selectedStatus,
      selectedDateRange: selectedDateRange,
    };
    toogleFilterView();
    handleApplyFilters(filters);
  };

  return (
    <>
      <SidePanel show={showFilter} containerPadding="p-0" onClose={toogleFilterView} allowCustomHeader={true}>
        <div className="flex flex-col flex-1 justify-between">
          <div>
            <div className="sticky top-0 border-b z-[1]">
              <div className="flex p-5 bg-white">
                <div className="w-filter-header">
                  <div className="text-base font-semibold text-gray-900">
                    <FormattedMessage {...messages.filter} />
                  </div>
                  <div className="text-sm font-normal text-gray-600">
                    <FormattedMessage {...messages.customize_view} />
                  </div>
                </div>
                <div
                  data-testid="close_btn"
                  role="button"
                  tabIndex={-1}
                  className="px-2 text-gray-600 cursor-pointer"
                  onClick={toogleFilterView}
                  onKeyPress={toogleFilterView}
                >
                  <XMarkIcon className="w-6 h-6" aria-hidden="true" />
                </div>
              </div>
            </div>
            <div className="flex flex-col px-6 py-3 bg-white">
              <div className="text-base font-semibold text-gray-900">
                <FormattedMessage {...messages.transaction_id} />
              </div>
              <div className="pt-2">
                <SearchInput
                  initialValue={transactionId}
                  handleChange={(value) => setTransactionId(value)}
                  placeholderMessageId="app.components.transactions.filters.search_for_transaction_id"
                />
              </div>
            </div>
            {/* NOTE: Hide for https://github.com/talview/webclients/issues/4921 */}
            {/* <div className="flex flex-col px-6 py-3 bg-white"> */}
            {/*   <div className="text-base font-semibold text-gray-900"> */}
            {/*     <FormattedMessage {...messages.drive_enrollment_id} /> */}
            {/*   </div> */}
            {/*   <div className="pt-2"> */}
            {/*     <SearchInput */}
            {/*       initialValue={driveEnrollmentId} */}
            {/*       handleChange={(value) => setDriveEnrollmentId(value)} */}
            {/*       placeholderMessageId="app.components.transactions.filters.search_for_drive_enrollment_id" */}
            {/*     /> */}
            {/*   </div> */}
            {/* </div> */}
            <div className="flex flex-col px-6 py-3 bg-white">
              <div className="text-base font-semibold text-gray-900">
                <FormattedMessage {...messages.attendee} />
              </div>
              <div className="pt-2">
                <SearchInput
                  initialValue={attendee}
                  handleChange={(value) => setAttendee(value)}
                  placeholderMessageId="app.components.transactions.filters.search_for_attendee"
                />
              </div>
            </div>
            {/* NOTE: Hide for https://github.com/talview/webclients/issues/4921 */}
            {/* <div className="flex flex-col px-6 py-3 bg-white"> */}
            {/*   <div className="text-base font-semibold text-gray-900"> */}
            {/*     <FormattedMessage {...messages.workflow} /> */}
            {/*   </div> */}
            {/*   <div className="pt-3"> */}
            {/*     <Dropdown */}
            {/*       id="workflow-list" */}
            {/*       isMulti={true} */}
            {/*       value={selectedWorkflow} */}
            {/*       isSearchable={true} */}
            {/*       placeholder={<FormattedMessage {...messages.select_workflow} />} */}
            {/*       onChange={(workflow) => setSelectedWorkflow(workflow as { label: string; value: string }[])} */}
            {/*       options={[]} */}
            {/*     /> */}
            {/*   </div> */}
            {/* </div> */}
            {/* <div className="flex flex-col px-6 py-3 bg-white"> */}
            {/*   <div className="text-base font-semibold text-gray-900"> */}
            {/*     <FormattedMessage {...messages.transaction_action} /> */}
            {/*   </div> */}
            {/*   <div className="pt-3"> */}
            {/*     <Dropdown */}
            {/*       id="transation-action-list" */}
            {/*       isMulti={true} */}
            {/*       value={selectedTransactionAction} */}
            {/*       isSearchable={true} */}
            {/*       placeholder={<FormattedMessage {...messages.select_transaction_action} />} */}
            {/*       onChange={(workflow) => setTransactionAction(workflow as { label: string; value: string }[])} */}
            {/*       options={transactionActionList?.length ? transactionActionList : []} */}
            {/*     /> */}
            {/*   </div> */}
            {/* </div> */}
            <div className="flex flex-col px-6 py-3 bg-white">
              <div className="text-base font-semibold text-gray-900">
                <FormattedMessage {...messages.transaction_date} />
              </div>
              <div className="flex pt-3">
                <DateRangePicker onClickOnDonebtn={(range) => setSelectedDateRange(range)} />
              </div>
            </div>
            <div className="flex flex-col px-6 py-3 bg-white">
              <div className="text-base font-semibold text-gray-900">
                <FormattedMessage {...messages.status} />
              </div>
              <div className="pt-3">
                <Dropdown
                  id="status-list"
                  isMulti={true}
                  value={selectedStatus}
                  isSearchable={true}
                  placeholder={<FormattedMessage {...messages.select_status} />}
                  onChange={(status) => {
                    setSelectedStatus(status as { label: string; value: string }[]);
                  }}
                  options={statusList.length ? statusList : []}
                />
              </div>
            </div>

            {/* <div className="flex flex-col px-6 py-3 bg-white"> */}
            {/*   <div className="text-base font-semibold text-gray-900"> */}
            {/*     <FormattedMessage {...messages.code} /> */}
            {/*   </div> */}
            {/*   <div className="pt-2"> */}
            {/*     <SearchInput */}
            {/*       initialValue={voucherCode} */}
            {/*       handleChange={(value) => setVoucherCode(value)} */}
            {/*       placeholderMessageId="app.components.transactions.filters.search_for_voucher_code" */}
            {/*     /> */}
            {/*   </div> */}
            {/* </div> */}
            {/* <div className="flex flex-col px-6 py-3 bg-white"> */}
            {/*   <div className="text-base font-semibold text-gray-900"> */}
            {/*     <FormattedMessage {...messages.country_of_residence} /> */}
            {/*   </div> */}
            {/*   <div className="pt-3"> */}
            {/*     <Dropdown */}
            {/*       id="country-list" */}
            {/*       isMulti={true} */}
            {/*       value={selectedCountry} */}
            {/*       isSearchable={true} */}
            {/*       placeholder={<FormattedMessage {...messages.select_country} />} */}
            {/*       onChange={(country) => setSelectedCountry(country as { label: string; value: number }[])} */}
            {/*       options={countryList.length ? countryList : []} */}
            {/*     /> */}
            {/*   </div> */}
            {/* </div> */}

            {/* <div className="flex flex-col px-6 py-3 bg-white"> */}
            {/*   <div className="text-base font-semibold text-gray-900"> */}
            {/*     <FormattedMessage {...messages.invoice_id} /> */}
            {/*   </div> */}
            {/*   <div className="pt-2"> */}
            {/*     <SearchInput */}
            {/*       initialValue={invoiceId} */}
            {/*       handleChange={(value) => setInvoiceId(value)} */}
            {/*       placeholderMessageId="app.components.transactions.filters.search_for_invoice_id" */}
            {/*     /> */}
            {/*   </div> */}
            {/* </div> */}
          </div>
          <div className="sticky bottom-0">
            <div className="h-20 flex items-center justify-start px-6 bg-white shadow-[0px_3px_45px_0px_#00000024]">
              <Button variant="outline" onClick={resetFilter}>
                <FormattedMessage {...messages.clear} />
              </Button>
              <div className="px-3">
                <Button onClick={applyFilter}>
                  <FormattedMessage {...messages.apply} />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </SidePanel>
    </>
  );
};

export default Filters;
